import { render, staticRenderFns } from "./UpdateUid.vue?vue&type=template&id=19cd7910&scoped=true&lang=pug&"
import script from "./UpdateUid.vue?vue&type=script&lang=js&"
export * from "./UpdateUid.vue?vue&type=script&lang=js&"
import style0 from "./UpdateUid.vue?vue&type=style&index=0&id=19cd7910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cd7910",
  null
  
)

export default component.exports